import React from 'react';
import { EmptyTableState, TableLoadingSkeleton, TableErrorState } from './EmptyTableState';

export const UsersEmptyState: React.FC<{
  hasFilters?: boolean;
  onCreateUser?: () => void;
  onClearFilters?: () => void;
  showImportOption?: boolean;
}> = ({ hasFilters = false, onCreateUser, onClearFilters, showImportOption = true }) => {
  return (
    <EmptyTableState
      title="No users found"
      description="Get started by adding your first user to the platform. Users represent individuals who can access and manage your application."
      hasFilters={hasFilters}
      onClearFilters={onClearFilters}
      primaryAction={onCreateUser ? {
        label: "Add Your First User",
        onClick: onCreateUser,
        icon: (
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
        )
      } : undefined}
      secondaryAction={showImportOption ? {
        label: "Import from CSV",
        onClick: () => console.log("Import CSV clicked"),
        icon: (
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
                  d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10" />
          </svg>
        )
      } : undefined}
    />
  );
};

export const UsersLoadingSkeleton: React.FC = () => <TableLoadingSkeleton rows={5} columns={7} />;

export const UsersErrorState: React.FC<{
  onRetry?: () => void;
  error?: string;
}> = ({ onRetry, error }) => (
  <TableErrorState 
    onRetry={onRetry}
    error={error || "Failed to load users"}
    title="Failed to load users"
  />
);
